import React from 'react';
import { Button, Table, Image, Modal } from 'semantic-ui-react';
import $ from "jquery";

import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Title from '../../title';
import AddModel from './add';
import Loading from '../../loading';
import Images from './image';
import Videos from './video';

class Model extends React.Component {

  state = {
    models: [], menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('machine', this.props.menus);
    if (menuPermission.view) {
      this.machineModel();
    }
    this.setState({ menuPermission })
  }

  machineModel() {
    let context = this;
    context.setState({ load: true, message: 'Getting Model' })
    $.ajax({
      type: 'POST',
      url: Server() + 'machinemodel/get.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          console.log(data);
          context.setState({ models: data, load: false })
        } catch (e) {
          alert('Error1!!!')
          context.setState({  load: false })
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  deleteModel() {
    let context = this;
    this.setState({ load: true, message: 'Dalete this Model' });
    $.ajax({
      type: 'POST',
      data: { id: context.state.deleteId },
      url: Server() + 'machinemodel/delete.php',
      success: function(data) {
        if (data == 1) {
          let model = context.state.models;
          let models = [];
          model.map((v) => {
            if (v.id != context.state.deleteId) {
              models.push(v);
            }
          });
          context.setState({ models, open: false, load: false })
        }
        else {
          alert('Error');
          context.setState({ load: false })
        }
      },
      error: function (e) {
        alert(e)
        context.setState({ load: false });
      }
    });
  }

  deleteConfirm(id) {
    if (!this.state.menuPermission.cancel) {
      alert("You Are Not Allow To Cancel!!!");
      return;
    }
    this.setState({ open: true, deleteId: id })
  }

  render() {
    let models = this.state.models;
    let sino = 1;
    let x = (<div></div>);
    x = models.map((v) => {
      return (
        <tr>
          <td><center>{sino++}</center></td>
          <td>{v.model_name}</td>
          <td>{v.tamil_name}</td>
          <td>{v.description}</td>
          <td>
            <Images menuPermission={this.state.menuPermission} id={v.id} />
          </td>
          <td>
            <Videos menuPermission={this.state.menuPermission} id={v.id} />
          </td>
          <td><center>
          { v.status == '1' ? 'Active':'Inactive'}
          </center></td>
          <td><center>{v.priority}</center></td>
          { this.state.menuPermission.edit ?
            (
              <td>
                <center>
                  <AddModel models={this.state.models} updateModels={ (models) => { this.setState({ models }); }} 
                  title={'Edit Model'} item={v} />
                </center>
              </td>
            ):''

          }
          
          <td onClick={this.deleteConfirm.bind(this, v.id)} style={{cursor: 'pointer', color: 'red'}}><center><u>{'Delete'}</u></center></td>
        </tr>
      )
    })
    return (
      <div>
        <Title title='Machine Model' openDrawer={this.props.openDrawer}/>
        <Loading load={this.state.load} message={this.state.message} />
        { this.state.menuPermission.view ?
          (
            <div style={{padding: '0.5%'}}>
              { this.state.menuPermission.add ?
                (
                  <AddModel machineModel={this.machineModel.bind(this)} title={'Add Model'} />
                ):''
              }
              <table id='table' width="100%">
                <tr>
                  <th id='tableheader' style={{width: '3%'}}><center>Sino</center></th>
                  <th id='tableheader' style={{width: '15%'}}><center>Model Name</center></th>
                  <th id='tableheader' style={{width: '15%'}}><center>Tamil Name</center></th>
                  <th id='tableheader' style={{width: '18%'}}><center>Description</center></th>
                  <th id='tableheader' style={{width: '6%'}}><center>Image</center></th>
                  <th id='tableheader' style={{width: '6%'}}><center>Video</center></th>
                  <th id='tableheader' style={{width: '10%'}}><center>Status</center></th>
                  <th id='tableheader' style={{width: '6%'}}><center>Priority</center></th>
                  { this.state.menuPermission.edit ?
                    (
                      <th id='tableheader' style={{width: '5%'}}><center>Edit</center></th>
                    ):''
                  }
                  <th id='tableheader' style={{width: '5%'}}><center>Delete</center></th>
                </tr>
                {x}
              </table>
            </div>
          ):
          (
            <center>
              You Are Not Allow To Access This Menu!!!
            </center>
          )
        }
        <Modal open={this.state.open} onClose={ () => { this.setState({ open: false }) }}>
          <Modal.Header>{'Delete Model'}</Modal.Header>
          <Modal.Content>
              Are you sure to delete this model?
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={ () => { this.setState({ open: false }) }} negative>
              Cancel
            </Button>
            <Button onClick={this.deleteModel.bind(this)} positive labelPosition='right' icon='checkmark' content='Yes' />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default Model;
